import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PatchAccountsForm } from 'projects/appcloud-admin-portal/src/app/models/patch-accounts-form.model';
import { Account } from 'projects/internal/r1-component-library/src/lib/components/appcloud-login/appcloud-credentials/appcloud-credentials.model';
import { MatFormField, MatError, MatPrefix, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { AccountPatch } from '../../../../../services/manage-accounts.service';

/**
 * Displays a form to edit an individual App Cloud account (accounts side panel).
 */
@Component({
    selector: 'r1-edit-account',
    templateUrl: './edit-account.component.html',
    styleUrls: ['./edit-account.component.scss'],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatError,
        MatIcon,
        MatPrefix,
        MatLabel,
        MatInput,
        MatButton,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditAccountComponent {
    readonly #formBuilder = inject(FormBuilder);

    account = input.required<Account>();
    patchAccountValue = output<AccountPatch & { id: number }>();

    readonly patchAccountsFormGroup: FormGroup<PatchAccountsForm> = this.#formBuilder.group(new PatchAccountsForm());

    constructor() {
        effect(() => {
            const account = this.account();
            this.patchAccountsFormGroup.reset({
                name: account.name ?? '',
                description: account.description ?? '',
                sfAccountId: account.sfAccountId ?? '',
            });
        });
    }

    onSubmit(): void {
        if (this.patchAccountsFormGroup.valid) {
            const { name, description, sfAccountId } = this.patchAccountsFormGroup.getRawValue();
            this.patchAccountValue.emit({ id: this.account().id!, name, description, sfAccountId });
        }
    }

    showError = (control: string, error: string) => {
        const formControl = this.patchAccountsFormGroup.get(control) as FormControl;
        return formControl?.hasError(error) ?? false;
    };
}
